"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppViews = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Loading = _interopRequireDefault(require("../../components/shared-components/Loading"));

var _AppConfig = require("../../configs/AppConfig");

var AppViews = function AppViews() {
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loading.default, {
      cover: "page"
    })
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(_AppConfig.AUTH_PREFIX_PATH, "/login"),
    component: /*#__PURE__*/(0, _react.lazy)(function () {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("./LoginPage/index"));
      });
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    from: "".concat(_AppConfig.AUTH_PREFIX_PATH),
    to: "".concat(_AppConfig.AUTH_PREFIX_PATH, "/login")
  })));
};

exports.AppViews = AppViews;
var _default = AppViews;
exports.default = _default;